import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { initializeApp } from "./actions/app/initialize";
import { Location } from '@angular/common';

export const initializeApplication = () => {
  const store = inject(Store);
  const location = inject(Location);

  return new Observable<void>((subscriber) => {
    subscriber.next();
    subscriber.complete();

    /**
     * Do not initialize the app state on specific paths
     * /auth/callback for example handles its own initialization logic
     */
    const exemptedPaths = [
      '/auth/callback',
    ];

    const isPathExempted = exemptedPaths.some((path) => location.path().includes(path));

    if (!isPathExempted) {
      store.dispatch(initializeApp());
    }
  });
};
